import { subscribe } from "../emitter-subscriber/subscribe";
import { getConfig } from "../config/config-store";
import { parsePayload } from "../utils/parse";
// rum
import { rumSend } from "../rum/rum-event";
import { eventTypes } from "../types/event-types";
import { getKey } from "../utils/key";
import { merge } from "../array.utils";
import { eventDetails } from "../event-details/event-details";
const createTimer = () => {
    const timers = new Map();
    const timerSubscription = () => {
        // subscribe('AAT_CONFIG_PASSIVE', (payload: { key?: string, [key: string]: any }) => {
        // });
        subscribe("AAT_TIME_PASSIVE", (payload) => {
            if ("label" in payload && typeof payload.label === "string") {
                const label = payload.label;
                timers.set(label, performance.now());
            }
        });
        subscribe("AAT_TIME_END_PASSIVE", (payload) => {
            if ("label" in payload && typeof payload.label === "string") {
                if (!timers.has(payload.label)) {
                    console.warn(`Timer with label "${payload.label}" does not exist.`);
                }
                else {
                    const startTime = timers.get(payload.label);
                    const endTime = performance.now();
                    const duration = endTime - startTime;
                    const interval = duration.toFixed(0);
                    let { action } = payload;
                    const storeConfig = getConfig(getKey(payload));
                    // console.log("parsed", parsePayload(payload));
                    const parsedPayload = storeConfig
                        ? Object.assign(Object.assign(Object.assign({}, merge(parsePayload(payload), storeConfig)), (action && { action })), (interval && { interval })) : Object.assign(Object.assign(Object.assign({}, parsePayload(payload)), (action && { action })), (interval && { interval }));
                    // console.log(parsedPayload);
                    // console.log(`Timer "${payload.label}": ${interval}`);
                    // console.log(`Timer "${label}": ${duration.toFixed(2)}ms`);
                    timers.delete(payload.label); // Clean up the timer
                    rumSend(eventDetails(parsedPayload, eventTypes.journeyRecord));
                }
            }
        });
    };
    return { timerSubscription };
};
export const { timerSubscription } = createTimer();



//////////////////
// WEBPACK FOOTER
// ./~/@celine/passive-tracking/dist/events/timer.js
// module id = ./node_modules/@celine/passive-tracking/dist/events/timer.js
// module chunks = 0